import React, { useEffect } from "react";
import { WizardFormField } from "../machines/immersive-wizard.machine";
import { WizardFormData } from "../types/wizard.types";
import FileUpload from "../components/FileUpload";

interface LogoStepProps {
  formData: WizardFormData;
  onFormUpdate: (data: Partial<WizardFormData>) => void;
  onValidationChange: (isValid: boolean) => void;
}

const LogoStep: React.FC<LogoStepProps> = ({
  formData,
  onFormUpdate,
  onValidationChange,
}) => {
  useEffect(() => {
    onValidationChange(true);
  }, [onValidationChange]);

  const currentFile = formData[WizardFormField.Logo]
    ? {
        base64: formData[WizardFormField.Logo],
        name: "logo.png", // We don't store the original filename for logos
      }
    : null;

  return (
    <FileUpload
      title="Upload your logo"
      onFileUploaded={(base64) => {
        onFormUpdate({
          [WizardFormField.Logo]: base64 || null,
        });
      }}
      acceptedTypes="image/jpeg,image/jpg,image/png"
      maxSizeMB={2}
      currentFile={currentFile}
      showPreview={true}
      previewSize="medium"
    />
  );
};

export default LogoStep;
